import type { HTMLAttributes } from 'react'
import { cx } from '../../cx'
import styles from './StatusPill.module.css'

/*
 * [D14]: ton „pink" jest dozwolony wyłącznie dla statusów procesowych
 * (np. etap w toku); statusy semantyczne to success/warning/danger.
 */

export type StatusPillTone = 'success' | 'warning' | 'danger' | 'pink' | 'neutral'

export interface StatusPillProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: StatusPillTone
  dot?: boolean
}

export function StatusPill({
  tone = 'neutral',
  dot = false,
  className,
  children,
  ...rest
}: StatusPillProps) {
  return (
    <span className={cx(styles.pill, styles[tone], className)} {...rest}>
      {dot ? <span className={styles.dot} aria-hidden="true" /> : null}
      {children}
    </span>
  )
}
